import { useBreakpoints } from "@vueuse/core";

const breakpointDefinitions = {
  mobile: 0,
  tablet: 640,
  laptop: 1024,
  desktop: 1280,
} as const;

export function useAppBreakpoints() {
  const breakpoints = useBreakpoints(breakpointDefinitions);

  const isMobile = breakpoints.between("mobile", "tablet");
  const smallerThanLaptop = breakpoints.smaller("laptop");
  const smallerThanDesktop = breakpoints.smaller("desktop");
  const isTablet = breakpoints.between("tablet", "laptop");
  const isLaptop = breakpoints.between("laptop", "desktop");
  const isDesktop = breakpoints.greater("desktop");

  return {
    breakpoints,
    isMobile,
    smallerThanLaptop,
    smallerThanDesktop,
    isTablet,
    isLaptop,
    isDesktop,
  };
}
